export class SceneInfoProjet {
    public performanceEcologique: number;
    public prix: number;

    public constructor () {
        this.prix = 0;
        this.performanceEcologique = 0;
    }
}